import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'app.components.SelectDimension.placeholder',
    defaultMessage: 'Select Dimension...',
    description: 'Default placeholder text for the select dimension component',
  },
  label: {
    id: 'app.components.SelectDimension.label',
    defaultMessage: 'Select Dimension',
    description: 'Label for the select dimension component',
  },
  clear: {
    id: 'app.components.SelectDimension.clear',
    defaultMessage: 'Clear all selected dimensions',
    description: 'Clear all selected dimensions',
  },
  ariaLabel: {
    id: 'app.components.SelectDimension.ariaLabel',
    defaultMessage: 'Select Dimension',
    description: 'Aria label for the select dimension component',
  },
})
